import { gql } from "@apollo/client";

export const Get_Workflows = gql`
  query GetWorkflow(
    $skip: Int
    $take: Int
    $where: WorkflowGridFilterInput
    $order: [WorkflowGridSortInput!]
  ) {
    workFlows(skip: $skip, take: $take, where: $where, order: $order) {
      items {
        id
        name
        type
        createdOn
        createdBy
        workflowRunStatus
        workflowRunId
        userDisplayName
      }
      totalCount
    }
  }
`;

export const Get_Workflow_By_Id = gql`
  query GetWorkflowById($id: Int!) {
    workFlow(id: $id) {
      items {
        id
        name
        description
        type
        templateId
        listId
        workflowRunStatus
        workflowRunId
        createdOn
        createdBy
        wfOptOutSetting {
          id
          optOutEducatingTextEnabled
          optOutEducatingText
          workflowId
        }
        wfTemplate {
          name
          id
          step {
            templateActions {
              id
              name
              description
              actionId
              data
              stepId
              workFlowTemplateId
              templateVersionNo
            }
            templateConditions {
              id
              name
              description
              data
              workFlowTemplateId
              conditionId
              conditionCriteriaId
              createdBy
              stepId
              groupId
              createdOn
            }
          }
          connectionsJson
        }
        triggers {
          id
          triggerId
          name
          workFlowId
          description
          data
          criteriaId
        }
      }
    }
  }
`;

export const Get_Workflows_By_Status = gql`
  query GetWorkflow($workflowRunStatus: [Int], $skip: Int, $take: Int) {
    workFlows(
      where: { and: { workflowRunStatus: { in: $workflowRunStatus } } }
      skip: $skip
      take: $take
    ) {
      items {
        id
        name
        workflowRunStatus
      }
      totalCount
    }
  }
`;

export const Get_Workflow_Templates = gql`
  query GetWorkflowTemplates(
    $skip: Int
    $take: Int
    $where: WFTemplateFilterInput
    $order: [WFTemplateSortInput!]
  ) {
    wfTemplatesGrid(skip: $skip, take: $take, where: $where, order: $order) {
      items {
        id
        name
        executedWorkflows
        createdOn
        createdBy
        userDisplayName
        templateState
        templateType
        version
        templateCategoryId
        templateCategory {
          id
          name
          isBusinessCategory
        }
      }
      totalCount
    }
  }
`;

export const Get_Workflow_Template_By_Id = gql`
  query GetWorkflowTemplateById($where: WFTemplateFilterInput) {
    wfTemplates(where: $where) {
      items {
        id
        name
        description
        connectionsJson
        templateState
        templateType
        version
        executedWorkflows
        templateCategoryId
        templateCategory {
          id
          name
          isBusinessCategory
        }
        step {
          templateActions {
            id
            name
            description
            actionId
            data
            stepId
            workFlowTemplateId
            templateVersionNo
          }
          templateConditions {
            id
            name
            description
            data
            workFlowTemplateId
            conditionId
            conditionCriteriaId
            createdBy
            stepId
            createdOn
            groupId
          }
        }
      }
    }
  }
`;

export const Get_Workflow_Default_Templates = gql`
  query GetWorkflowDefaultTemplates(
    $skip: Int
    $take: Int
    $where: WFDefaultTemplateFilterInput
    $order: [WFDefaultTemplateSortInput!]
  ) {
    wfDefaultTemplates(skip: $skip, take: $take, where: $where, order: $order) {
      items {
        id
        name
        executedWorkflows
        createdOn
        createdBy
        userDisplayName
        templateState
        templateType
        version
        businessCategoryIds
        templateCategoryId
        templateCategory {
          id
          name
          isBusinessCategory
        }
      }
      totalCount
    }
  }
`;

export const Get_Workflow_Default_Template_By_Id = gql`
  query GetWorkflowDefaultTemplateById($where: WFDefaultTemplateFilterInput) {
    wfDefaultTemplates(where: $where) {
      items {
        id
        name
        description
        connectionsJson
        templateState
        templateType
        version
        businessCategoryIds
        templateCategoryId
        templateCategory {
          id
          name
          isBusinessCategory
        }
        step {
          templateActions {
            id
            name
            description
            actionId
            data
            stepId
            workFlowTemplateId
            templateVersionNo
          }
          templateConditions {
            id
            name
            description
            data
            workFlowTemplateId
            conditionId
            conditionCriteriaId
            createdBy
            stepId
            createdOn
            groupId
          }
        }
      }
    }
  }
`;

export const Get_WF_Actions = gql`
  query {
    workFlowActions {
      items {
        id
        name
        description
        type
        categoryName
      }
    }
  }
`;

export const Get_WF_WaitTypes = gql`
  query {
    wfWaitTypes {
      items {
        id
        name
        parentId
      }
    }
  }
`;

// task is removed for now thay is why id 4 is removed
export const Get_WF_Triggers_Category = gql`
  query {
    workFlowTriggerCategories(where: { id: { neq: 4 } }) {
      items {
        id
        title
        order
      }
    }
  }
`;

export const Get_WF_Triggers = gql`
  query {
    workFlowTriggers {
      items {
        id
        name
        description
        triggerCategoryId
        key
        triggerCriteria {
          id
          title
          triggerId
          triggerCriteriaColumn {
            triggerCriteriaId
            columnKey
          }
        }
      }
    }
  }
`;

export const Get_Manually_Enrolled_Workflow_Leads = gql`
  query ManuallyEnrolledWorkflowLeads(
    $skip: Int
    $take: Int
    $where: WorkFlowLeadFilterInput
    $order: [WorkFlowLeadSortInput!]
  ) {
    manuallyEnrolledWorkflowLeads(
      skip: $skip
      take: $take
      where: $where
      order: $order
    ) {
      items {
        leadId
        workFlowId
        firstName
        lastName
        email
        phone
      }
      totalCount
    }
  }
`;
export const Get_Enrolled_Workflow_Leads_Count = gql`
  query ManualEnrolledLeads($where: WorkFlowLeadFilterInput) {
    manuallyEnrolledWorkflowLeads(where: $where) {
      totalCount
    }
  }
`;

export const Get_Business_Categories = gql`
  query GetBusinessCategories(
    $skip: Int
    $take: Int
    $where: BusinessCategoryFilterInput
    $order: [BusinessCategorySortInput!]
  ) {
    businessCategory(skip: $skip, take: $take, where: $where, order: $order) {
      items {
        id
        name
      }
      totalCount
    }
  }
`;

export const Get_Template_Categories = gql`
  query {
    wfTemplateCategories {
      items {
        id
        name
        isBusinessCategory
        createdOn
      }
    }
  }
`;
export const Get_Industries = gql`
  query {
    industries {
      id
      name
    }
  }
`;
export const Get_Workflows_Options = gql`
  query GetWorkflowsList(
    $skip: Int
    $take: Int
    $where: WorkflowGridFilterInput
    $order: [WorkflowGridSortInput!]
  ) {
    workFlows(skip: $skip, take: $take, where: $where, order: $order) {
      totalCount
      items {
        id
        name
      }
    }
  }
`;

export const Get_Company_Business_Category = gql`
  query GetBusinessCategories($companyKey: String!) {
    companyBusinessCategory(companyKey: $companyKey) {
      items {
        id
        name
      }
    }
  }
`;

export const Get_Template_Conditions = gql`
  query {
    wfTemplateConditions {
      items {
        name
        id
        conditionCategoryId
        conditionCriteria {
          id
          title
          conditionId
          conditionCriteriaColumn {
            columnKey
            conditionCriteriaId
          }
        }
      }
    }
  }
`;

// Stats Queries
export const Get_Workflow_Enrolled_Leads_Count = gql`
  query GetWorkflowEnrolledLeadsCounts($workflowIds: [Int!]!) {
    workflowEnrolledLeadsCount(workflowIds: $workflowIds) {
      items {
        workflowId
        leadCount
      }
    }
  }
`;
export const Get_Workflow_Active_Leads_Count = gql`
  query GetWorkflowActiveLeadsCount($workflowIds: [Int!]!) {
    workflowActiveLeadsCount(workflowIds: $workflowIds) {
      items {
        workflowId
        leadCount
      }
    }
  }
`;
export const Get_Workflow_Lead_Bounce_Rate = gql`
  query GetWorkflowLeadBounceRate($workflowIds: [Int!]!) {
    workflowLeadBounceRate(workflowIds: $workflowIds) {
      items {
        workflowId
        rate
      }
    }
  }
`;
export const Get_Workflow_Lead_Response_Rate = gql`
  query GetWorkflowLeadResponseRate($workflowIds: [Int!]!) {
    workflowLeadResponseRate(workflowIds: $workflowIds) {
      items {
        workflowId
        rate
      }
    }
  }
`;
export const Get_Workflow_Lead_OptOut_Rate = gql`
  query GetWorkflowLeadOptedOutRate($workflowIds: [Int!]!) {
    workflowLeadOptedOutRate(workflowIds: $workflowIds) {
      items {
        workflowId
        rate
      }
    }
  }
`;

export const Get_Workflow_Enrolled_Leads = gql`
  query GetWorkflowEnrolledLeads(
    $skip: Int
    $take: Int
    $workflowId: Int!
    $where: WorkflowLeadStatsFilterInput
    $order: [WorkflowLeadStatsSortInput!]
  ) {
    enrollLeads(
      skip: $skip
      take: $take
      workflowId: $workflowId
      where: $where
      order: $order
    ) {
      items {
        firstName
        lastName
        email
        phone
        sourceType
      }
      totalCount
    }
  }
`;
export const Get_Workflow_Active_Leads = gql`
  query GetWorkflowActiveLeads(
    $skip: Int
    $take: Int
    $workflowId: Int!
    $where: WorkflowLeadStatsFilterInput
    $order: [WorkflowLeadStatsSortInput!]
  ) {
    activeLeads(
      skip: $skip
      take: $take
      workflowId: $workflowId
      where: $where
      order: $order
    ) {
      items {
        firstName
        lastName
        email
        phone
        sourceType
      }
      totalCount
    }
  }
`;
export const Get_Workflow_Bounced_Leads = gql`
  query GetWorkflowBouncedLeads(
    $skip: Int
    $take: Int
    $workflowId: Int!
    $where: WorkflowLeadStatsFilterInput
    $order: [WorkflowLeadStatsSortInput!]
  ) {
    bouncedLeads(
      skip: $skip
      take: $take
      workflowId: $workflowId
      where: $where
      order: $order
    ) {
      items {
        firstName
        lastName
        email
        phone
        sourceType
      }
      totalCount
    }
  }
`;
export const Get_Workflow_Response_Leads = gql`
  query GetWorkflowResponseLeads(
    $skip: Int
    $take: Int
    $workflowId: Int!
    $where: WorkflowLeadStatsFilterInput
    $order: [WorkflowLeadStatsSortInput!]
  ) {
    responseLeads(
      skip: $skip
      take: $take
      workflowId: $workflowId
      where: $where
      order: $order
    ) {
      items {
        firstName
        lastName
        email
        phone
        sourceType
      }
      totalCount
    }
  }
`;

export const Get_Workflow_OptedOut_Leads = gql`
  query GetWorkflowOptedOutLeads(
    $skip: Int
    $take: Int
    $workflowId: Int!
    $where: WorkflowLeadStatsFilterInput
    $order: [WorkflowLeadStatsSortInput!]
  ) {
    optedOutLeads(
      skip: $skip
      take: $take
      workflowId: $workflowId
      where: $where
      order: $order
    ) {
      items {
        firstName
        lastName
        email
        phone
        sourceType
      }
      totalCount
    }
  }
`;
